/**
 * Adobe Profile Photo Service (PPS) endpoint + api-key by deploy environment.
 * Replaces the decommissioned cc-collab endpoint; supplies the avatar image.
 * Requires the `pps.read` scope on the IMS client (see AdobeIMS `scope`).
 *
 * Keyed off `window.apcConfig.ims.environment` ('stg1' for dev/qa/stage/local, 'prod' for prod).
 */
const BY_ENV = {
  stg1: {
    endpoint: 'https://pps-stage.adobe.io/api/profile',
    apiKey: 'apc-contact-reg-stage',
  },
  prod: {
    // TODO: confirm prod PPS host before deploy (stage uses pps-stage.adobe.io)
    endpoint: 'https://pps.adobe.io/api/profile',
    apiKey: 'apc-contact-reg',
  },
};

const fallback = BY_ENV.stg1;

export function getPpsProfileConfig() {
  const env =
    typeof window !== 'undefined' && window.apcConfig?.ims?.environment?.toLowerCase()
      ? String(window.apcConfig.ims.environment).toLowerCase()
      : 'stg1';
  return BY_ENV[env?.toLowerCase()] ?? fallback;
}
